import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class PlanningDashboardLanesController extends Controller {
  @service roadmap;

  initiativeOptions = [];

  @action
  updateSelectedInitiatives() {}

  @action
  removeInitiative() {}
}
